export enum SwapFreeOptionKey {
  country = 'countryId',
  green = 'green',
  red = 'red',
  daysTillSuspended = 'daysTillSuspended',
  enabled = 'enabled',
}
